import {
  Filter,
  TextInput,
  SelectInput,
  ReferenceInput,
  BooleanInput,
  DateInput
} from "react-admin";

export const UsersFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="search" alwaysOn />
    <SelectInput
      source="type"
      choices={[
        { id: "farmer", name: "مزارع (Farmer)" },
        { id: "cooperative", name: "تعاونية (Cooperative)" },
        { id: "service_provider", name: "شركة (Service Provider)" },
        { id: "buyer", name: "مشتري (Buyer)" },
        { id: "marketer", name: "Marketer" },
        { id: "supplier", name: "Supplier" },
      ]}
      optionText="name"
      optionValue="id"
      allowEmpty
    />
    <SelectInput
      source="cooperativeType"
      label="Cooperative Type"
      choices={[
        { id: "agriculture", name: "زراعية إنتاجية" },
        { id: "consumer", name: "إستهلاكية" },
      ]}
      optionText="name"
      optionValue="id"
      allowEmpty
    />
    <SelectInput
      source="gender"
      choices={[
        { id: "male", name: "ذكر (Male)" },
        { id: "female", name: "أنثى (Female)" },
      ]}
      optionText="name"
      optionValue="id"
      allowEmpty
    />
    <ReferenceInput
      label="State"
      source="location"
      reference="state"
      allowEmpty
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
    <BooleanInput source="isSubscribed" label="Is Subscribed" />
    <DateInput source="created_at_gte" label="Created After" />
    <DateInput source="created_at_lte" label="Created Before" />
  </Filter>
);

export default UsersFilter;